import React, { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import LinearProgress from "@mui/material/LinearProgress";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import authBgImg from "../../images/bg-img.png";
import useApp from "../../store/contexts/AppContext";
import Copyright from "../../components/Copyright/Copyright";
import { useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export default function VerifyAccount() {
  const {
    appState: { appName },
    VerifyAccountApiCall,
    resetApp,
  } = useApp();

  const location = useLocation();
  resetApp();

  const searchParams = new URLSearchParams(location.search);
  //get the value of token on the url query
  const userToken = searchParams.get("token");

  const hour = new Date().getHours();
  const isDay = hour >= 6 && hour < 18;
  const authTheme = createTheme({
    palette: {
      mode: isDay ? "light" : "dark",
      primary: { main: "#d44401" },
      background: {
        default: isDay ? "#f8f9fa" : "#0a0a0a",
        paper: isDay ? "#ffffff" : "#0a0a0a",
      },
    },
  });

  useEffect(() => {
    VerifyAccountApiCall(userToken);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={authTheme}>
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${authBgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: isDay ? "#f8f9fa" : "#0a0a0a",
          backgroundSize: "cover",
          // backgroundPosition: "center",
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
          }}
        >
          <Box align="center">
            <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
          </Box>
          <Typography component="h1" variant="h5" align="center">
            Verify account on {appName}
          </Typography>

          <Box component="form" sx={{ mt: 1 }}>
            <Typography sx={{ mt: 3, mb: 2, color: "primary.main" }} align="center">
              Account verification in progress
            </Typography>
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
            <Copyright sx={{ mt: 5 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
    </ThemeProvider>
  );
}
